import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailerBrandFollow) {
    (function(FollowSource) {
        FollowSource["FOLLOW_SOURCE_UNKNOWN"] = "FOLLOW_SOURCE_UNKNOWN";
        FollowSource["RETAILER"] = "RETAILER";
        FollowSource["ORDER"] = "ORDER";
        FollowSource["MARKET_LIST"] = "MARKET_LIST";
    })(IRetailerBrandFollow.FollowSource || (IRetailerBrandFollow.FollowSource = {}));
    IRetailerBrandFollow.build = function(partial) {
        return _object_spread({
            products: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailerBrandFollow || (IRetailerBrandFollow = {}));
export var IRetailerBrandFollow;
